import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { FaChartPie, FaChevronDown, FaPhone, FaPlayCircle, FaUser } from "react-icons/fa";
import { FaGear, FaUserGear } from "react-icons/fa6";
import IconComponent from './Icon';
import { LuLogOut } from "react-icons/lu";
import userGirl from '../assets/images/user-girl.svg';
import { useNavigate } from 'react-router-dom';

const UserDropDown = () => {
    const userRole = JSON.parse(localStorage.getItem('bibloUser') || '{}').role;

    const solutions = [
        { name: 'Profile', description: '', href: '/profile', icon: FaUser, adminOnly: false },
        // { name: 'Settings', description: '', href: '#', icon: FaGear },
        { name: 'Admin', description: "", href: '/admin', icon: FaUserGear, adminOnly: true  },
      ]
      const callsToAction = [
        { name: 'Logout', href: '', icon: LuLogOut, adminOnly: false },
      ]
      const navigate = useNavigate();
    return (
        <Popover className="relative">
            <PopoverButton className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900 outline-none">
                    <div className='user-icon-bg'>
                        <img src={userGirl} alt="user" width={'20px'} />
                    </div>
            </PopoverButton>

            <PopoverPanel
                transition
                className="absolute z-10 mt-5 flex w-screen max-w-max right-0 px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
            >
                <div className="w-screen max-w-52 flex-auto overflow-hidden rounded-3xl bg-white text-sm/6 shadow-lg ring-1 ring-gray-900/5">
                <div className="p-4">
                    {solutions.filter((item) => !item.adminOnly || userRole === 'ADMIN' ).map((item) => (
                    <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-2 hover:bg-gray-50 items-center">
                        <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                            <item.icon aria-hidden="true" className="size-4 text-gray-600 group-hover:text-indigo-600" />
                        </div>
                    <div>
                        <a href={item.href} className="font-semibold text-gray-900">
                            {item.name}
                            <span className="absolute inset-0" />
                        </a>
                        </div>
                    </div>
                    ))}
                </div>
                <div className="bg-gray-50">
                   
                    <div
                        key="logout"
                        className="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                            localStorage.removeItem('accessToken');
                            localStorage.removeItem('refreshToken');
                            localStorage.removeItem('bibloUser');
                            navigate('/login');
                        }}  
                    >
                        <IconComponent icon={LuLogOut} width={20} color='#000' className="size-5 flex-none text-gray-400" />
                        Logout
                    </div>
                </div>
                </div>
            </PopoverPanel>
    </Popover>
        
);
}

export default UserDropDown;